import { useParams } from '@xing-com/crate-core-router';
import { SubpageContainer } from '@xing-com/crate-entity-pages-subpage';
import type { Xinglet } from '@xing-com/crate-xinglet';

import { ContactsDetail } from './contacts-detail';

export default class ArticleViewer implements Xinglet {
  public getComponent() {
    return () => {
      const { slug } = useParams();

      return (
        <SubpageContainer pageSlug={slug} pageType="contacts">
          <ContactsDetail />
        </SubpageContainer>
      );
    };
  }
}
